<!--MODAL Agregar Motivo-->
<div mdbModal #agregarMotivo="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]='formData' novalidate (ngSubmit)="addEdit()">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="!isEditing">
            Agregar
          </h4>
          <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="isEditing">
            Editar
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarMotivo.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="container">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos del motivo
              </h5>
            </div>
            <div class="col">
              <div class="switch info-switch">
                <label
                  >Inactivo<input
                    type="checkbox"
                    color="info"
                    checked=""
                    formControlName="activo"
                  /><span class="lever"></span> Activo
                </label>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input
                  value=""
                  type="text"
                  id="xglosa"
                  class="form-control"
                  placeholder="Descripción"
                  required
                  #glosa
                  formControlName="descripcion"
                />
                <label for="glosa">Descripción</label>
              </div>
            </div>

            <div class="col">
              <div class="md-form">
                <mdb-select
                  [options]="optionsBodega"
                  formControlName="bodega"
                  [multiple]="false"
                  [filterEnabled]="true"
                  [highlightFirst]="false"
                  placeholder="Seleccionar bodega"
                ></mdb-select>
                <label>Bodega asociada</label>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="agregarMotivo.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect type="submit">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>